// utils/tokenNormalize.ts
export function parsePossiblyDoubleEncodedJSON(s: string): unknown {
    let v: unknown = s;
    // Tant que c’est une string JSON valide, on parse (max 3 tours pour éviter boucle)
    for (let i = 0; i < 3 && typeof v === 'string'; i++) {
        try {
            v = JSON.parse(v);
        } catch {
            break;
        }
    }
    return v;
}

export function extractAccessRefresh(plain: string): { access?: string; refresh?: string } {
    const v = parsePossiblyDoubleEncodedJSON(plain);
    if (v && typeof v === 'object' && 'access' in v) {
        const obj = v as Record<string, unknown>;
        return {
            access: typeof obj.access === 'string' ? obj.access : undefined,
            refresh: typeof obj.refresh === 'string' ? obj.refresh : undefined,
        };
    }
    // fallback: si le plaintext est directement un JWT (pas un JSON)
    if (/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(plain)) {
        return { access: plain };
    }
    return {};
}
